import { render, staticRenderFns } from "./brief-infroduction.vue?vue&type=template&id=171a9532&scoped=true&"
import script from "./brief-infroduction.vue?vue&type=script&lang=js&"
export * from "./brief-infroduction.vue?vue&type=script&lang=js&"
import style0 from "./brief-infroduction.vue?vue&type=style&index=0&id=171a9532&prod&lang=less&"
import style1 from "./brief-infroduction.vue?vue&type=style&index=1&id=171a9532&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171a9532",
  null
  
)

export default component.exports